import { Icon, Icons } from "@ir/ui";
import {
  SearchInput,
  type SearchInputProps,
} from "@src/presentation/components/common";
import { MasterDataSearchBy } from "./MasterDataSearchBy";

interface MasterDataSearchInputProps
  extends Omit<SearchInputProps, "prefix" | "suffix"> {
  fields: readonly string[];
  searchByTitle?: string;
}

/**
 * Master Data list search: Search by Popover on the left, search icon on the right.
 */
export function MasterDataSearchInput({
  fields,
  searchByTitle,
  ...searchProps
}: Readonly<MasterDataSearchInputProps>) {
  return (
    <SearchInput
      {...searchProps}
      prefix={<MasterDataSearchBy fields={fields} title={searchByTitle} />}
      suffix={
        <Icon
          name={Icons.Search}
          size="small"
          color="grey"
          style={{ color: "var(--grey-400)" }}
        />
      }
    />
  );
}
